import { useDataLayer, GenericEvent } from '@/hooks/use-data-layer';
import { useLocalization } from '@/hooks/use-localization';

export const DocumentLink = ({ href, title, parent }: { href: string; title: string; parent: string }) => {
    const { dataLayerPush } = useDataLayer();
    const { localize } = useLocalization();

    const sendDataLayerEvent = () => {
        const event: GenericEvent = {
            event: 'PDFEngagement',
            FormType: parent,
            FormName: title,
        };

        dataLayerPush(event, { usePageProductData: true });
    };

    return (
        <div data-component="document-link" className="r-flex r-content-center r-items-start r-gap-1">
            <img src="/assets/icons/document.svg" width={20} height={20} alt="" className="r-py-1.5" />
            <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => sendDataLayerEvent()}
                href={href?.replaceAll('&amp;', '&')}
                className="external-link no-icon r-flex r-items-start r-gap-2 r-py-1.5 r-text-sm"
            >
                <span>{title}</span>
                <img src="/assets/icons/arrow-out-black.svg" width={16} height={16} alt="" className="r-ml-0.5" />
                <span className="r-sr-only">
                    {localize('external-link')}, {localize('opens-in-new-tab')}
                </span>
            </a>
        </div>
    );
};
